module.exports = __webpack_public_path__ + "public/img/logo-ibcsd.07c4f0a6.png";